export type ManualUnitReadyStatus = 'READY' | 'IN_PROGRESS' | 'NOT_STARTED'
export type UnitReadyLabel = 'Ready' | 'In Progress' | 'Not Started'

export interface ManualUnitReadyMark {
    id: number
    status: ManualUnitReadyStatus
    markedByName: string | null
    markedDate: string | null
}

export const UNIT_READY_LABEL: Record<ManualUnitReadyStatus, UnitReadyLabel> = {
    READY: 'Ready',
    IN_PROGRESS: 'In Progress',
    NOT_STARTED: 'Not Started',
}

export const UNIT_READY_API_STATUS: Record<
    UnitReadyLabel,
    ManualUnitReadyStatus
> = {
    Ready: 'READY',
    'In Progress': 'IN_PROGRESS',
    'Not Started': 'NOT_STARTED',
}

export const formatManualUnitReady = (mark: ManualUnitReadyMark) => {
    const label = UNIT_READY_LABEL[mark.status] ?? mark.status
    const who = mark.markedByName || 'a user'
    const when = mark.markedDate
        ? new Date(mark.markedDate).toLocaleString(undefined, {
              month: 'short',
              day: 'numeric',
              year: 'numeric',
              hour: 'numeric',
              minute: '2-digit',
          })
        : ''
    return when
        ? `Manually set to ${label} by ${who} on ${when}`
        : `Manually set to ${label} by ${who}`
}
